import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "home"
  }, [_c('Header'), _c('div', {
    staticClass: "usercont content"
  }, [_c('NavMenu'), _c('div', {
    staticClass: "menucont"
  }, [_c('div', {
    staticClass: "feedback"
  }, [_c('h3', [_vm._v("问题类型")]), _c('ul', _vm._l(_vm.feedbackList, function (item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function click($event) {
          return _vm.selectFeedBack(item.id, index);
        }
      }
    }, [_c('i', {
      class: _vm.currentIndex === index ? 'iconfont icongouxuanxuanzhong active' : 'iconfont iconweigouxuan'
    }), _vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0), _c('el-input', {
    staticClass: "remark",
    attrs: {
      "type": "textarea",
      "maxlength": "500",
      "placeholder": "请输入详细问题，您的意见和建议是我们前进的动力",
      "autocomplete": "off",
      "show-word-limit": ""
    },
    on: {
      "input": function input($event) {
        return _vm.handleChange();
      }
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  }), _c('p', {
    class: {
      'active': _vm.isRemark
    }
  }, [_vm._v("反馈内容不能为空，请描述一下吧！")]), _c('div', {
    staticClass: "remarkimg"
  }, [_c('ol', [_vm._l(_vm.fileList, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      attrs: {
        "src": item.sourceUrl
      }
    }), _c('i', {
      staticClass: "iconfont icondeletex",
      on: {
        "click": function click($event) {
          return _vm.removefile(index);
        }
      }
    })]);
  }), !_vm.maxpic ? _c('li', {
    staticClass: "upload"
  }, [_c('input', {
    ref: "upload",
    attrs: {
      "type": "file",
      "multiple": "multiple"
    },
    on: {
      "change": function change($event) {
        return _vm.uploadpic($event);
      }
    }
  }), _c('i', {
    staticClass: "iconfont icontupian"
  }), _c('span', [_vm._v("（" + _vm._s(_vm.fileList.length) + "/3）")])]) : _vm._e()], 2)]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.mobileNo,
      expression: "mobileNo"
    }],
    staticClass: "email",
    attrs: {
      "type": "text",
      "placeholder": "请填写您的手机号或邮箱（选填）",
      "maxlength": "20"
    },
    domProps: {
      "value": _vm.mobileNo
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.mobileNo = $event.target.value;
      }
    }
  }), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.saveFeedback
    }
  }, [_vm._v("提交")])], 1)])], 1), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };